import * as React from "react";

import DeprecatedButton from "@v1/components/designSystem/button/Button";
import { isDevelopment } from "@v2/utils/env";
import { getProjectPreviewImageUrl } from "replo-utils/lib/project";

type ProjectImageProps = {
  projectId: string;
  workspaceId: string;
  onSelectProject: (e: React.MouseEvent) => void;
};

const ProjectImage: React.FC<ProjectImageProps> = ({
  projectId,
  workspaceId,
  onSelectProject,
}) => {
  const [imageLoaded, setImageLoaded] = React.useState(false);
  const [imageError, setImageError] = React.useState(false);
  const imageS3Url = getProjectPreviewImageUrl({
    workspaceId,
    projectId,
    env: isDevelopment ? "dev" : process.env.NODE_ENV,
  });

  return (
    <div
      className="bg-sheet group relative cursor-pointer gap-2 rounded-t-lg p-4"
      onClick={onSelectProject}
    >
      <>
        <div className="absolute inset-0 bg-white/50 opacity-0 transition-opacity group-hover:opacity-100" />
        <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity group-hover:opacity-100">
          <DeprecatedButton variant="primary">Open Project</DeprecatedButton>
        </div>
        {imageError ? (
          <div className="bg-sheet aspect-video w-full" />
        ) : (
          <div className="aspect-video w-full overflow-hidden">
            <img
              src={`${imageS3Url}?t=${Date.now()}`}
              className={`w-full object-contain object-top transition-opacity duration-300 ${
                imageLoaded ? "opacity-100" : "opacity-0"
              }`}
              alt={`Project Preview ${projectId}`}
              onLoad={() => setImageLoaded(true)}
              onError={() => setImageError(true)}
            />
          </div>
        )}
      </>
    </div>
  );
};

export default ProjectImage;
